var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{ref:"input",attrs:{"placeholder":_vm.placeholder,"size":"mini","loading":_vm.loading},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }